export const DEFAULT_LANG = "vi";
export const SUPPORTED_LOCALES = ["en", "vi", "ja"];
export const LOCALE_LABELS = {
  en: "English",
  vi: "Tiếng Việt",
  ja: "日本語",
};

export const COLOR_REQUEST = {
  GET: "#0cbb52",
  POST: "#f9c336",
  PUT: "#097bed",
  PATCH: "#212121",
  DELETE: "#eb2013",
};

export const QUIZ_TYPE = {
  HOME: "ホーム用",
  KANJI_ROMAJI: "Kanji",
  KANJI_TEXT: "漢字",
};

export const COLLECTION = {
  KANJI: "kanji",
  MOJI_GOI: "moji-goi",
  GOI: "goi",
  MONDAIS: "mondais",
  QUIZS: "quizs",
};
